<template>
  <div>
    <div class="col-md-12 col-xs-12">
      <p class="payment-header">Payment Methods</p>
      <div class="payment-method-wrapper">
        <div v-for="(method, index) in paymentOptions" :key="index">
          <div class="payment-methods" :class="([1, 2, 3].includes(method.id)) && 'disable-payment'">
            <label class="mb-0">
            <input class="radio-btn" type="radio" :value="method.id" v-model="payment_method_id" @change="selectedPaymentMethod(method)" />
            <span class="payment-method">{{method.mode}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-12 footer_buttons">
      <div class="col-md-6 col-xs-6 col-sm-6  footer_left_button">
        <button type="button" class="btn btn-block ul_back_button" @click="goBackToBillingInfo">{{$t('back')}}</button>
      </div>
      <div class="col-xs-6 footer_right_buttons_section">
            <button type="button" class="btn btn-block cancel_button" @click="goBackToBillingInfo">{{$t('cancel')}}</button>
            <button
              type="button"
              class="save_changes_button"
              :disabled="disableContinue()"
              @click="goToBillingInfoPage"
            >{{$t('continue')}}</button>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import { getAllPaymentModes } from '../../../apis/marketPlace';
import Loader from '../../UIComponents/Loader.vue';

export default {
  components: { Loader },
  props: ['fromDetails'],
  data() {
    return {
      paymentOptions: [],
      payment_method_id: '',
      payment_method_name: '',
      loaderStatus: false,
    };
  },
  methods: {
    selectedPaymentMethod(val) {
      this.payment_method_id = val.id;
      this.payment_method_name = val.mode;
    },
    disableContinue() {
      return !this.payment_method_id;
    },
    goToBillingInfoPage() {
      this.$emit('goToBilling', { from: 'paymentMethod', paymentId: this.payment_method_id });
    },
    goBackToBillingInfo() {
      this.$emit('goBackToBillingInfo');
    },
  },
  async mounted() {
    this.loaderStatus = true;
    this.paymentOptions = await getAllPaymentModes();
    let otherPaymentOptions = [];
    if (this.$i18n.locale === 'English') {
      otherPaymentOptions = [{ id: 1, mode: 'Credit Card' }, { id: 2, mode: 'Online Banking' }, { id: 3, mode: 'Boleto' }];
    } else {
      otherPaymentOptions = [{ id: 1, mode: 'Cartão de Crédito' }, { id: 2, mode: 'Online Banking' }, { id: 3, mode: 'Boleto' }];
    }
    this.paymentOptions = [...otherPaymentOptions, ...this.paymentOptions];
    if (this.fromDetails.paymentId) {
      this.payment_method_id = this.fromDetails.paymentId;
    }
    this.loaderStatus = false;
  },
};
</script>

<style scoped>
.disable-payment {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}
button.save_changes_button:disabled {
  opacity: 0.5 !important;
}
.payment-method-wrapper {
  padding: 10px 48px 20px 46px;
}
.footer_buttons {
  bottom: 16px;
  padding: 0px;
  background: #ffffff;
}
.footer_right_buttons_section {
  display: flex;
  column-gap: 16px;
  justify-content: flex-end;
}
.payment-header {
  color: #333;
  font-weight: 600;
  font-size: 18px;
}
.payment-methods {
  background: #ffffff;
  border: 1px solid #b3b3b3;
  padding: 24px 24px 30px 16px;
  margin-bottom: 24px;
  font-size: 20px;
  line-height: 27px;
  color: #3E3E3E;
}
.payment-method {
  font-weight: 600;
}
label>input[type="radio"] {
  display: none;
}
label>input[type="radio"][disabled] {
  cursor: not-allowed;
}
label>input[type="radio"]+*::before {
  content: "";
  display: inline-block;
  vertical-align: bottom;
  width: 18px;
  height: 18px;
  margin-right: 8px;
  margin-bottom: 4px;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  border-color: #4D4D4D;
}
label>input[type="radio"].radio-btn+*::before {
  margin-right: 16px;
}
label>input[type="radio"]:checked+*::before {
  background: radial-gradient(#00518A 0%, #00518A 46%, transparent 51%, transparent);
  border-color: #00518A;
}
@media (min-width: 1898px) {
  .footer_buttons {
    position: absolute;
    bottom: 24px;
    padding-bottom: 0px;
  }
}
</style>
